import { render, staticRenderFns } from "./WebinarArchive.vue?vue&type=template&id=45b26fb8"
import script from "./WebinarArchive.vue?vue&type=script&lang=js"
export * from "./WebinarArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports